import React from 'react'
import './insurance_products.scss'
import {  Breadcrumb, PageHeaderIntro, NewsCard } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const InsuranceProduct = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
    ];
    const HeaderData = [
        {
            image: images['two-people-on-tandem-bicycle.svg'],
            para: 'You want to protect your business and plan for your future. As one of the financially strongest mutual insurance companies in the country, we’re ready to help you find the insurance solutions you’re looking for.',
            para1: 'Whether you’re a small business owner or you’re seeking coverage for a large corporation with complex risks, we have a wide range of business insurance products that can help you protect what matters most.',
        },
    ];
    const NewsCardData = [
        {
          id: 1,
          title: '401(k) and other retirement plans',
          description:
            'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
          linkUrl: '',
          linkText: 'More about 401(k) plans >',
        },
        {
          id: 2,
          title: '401(k) and other retirement plans, plus life insurance',
          description:
            'We’ll work together to help you plan for the future.',
          linkUrl: '/',
          linkText: 'More about 401(k) plans and life insurance >',
        },
        {
          id: 3,
          title: 'Builder’s risk insurance',
          description:
            'Protect your profits and property from the unexpected during a construction or renovation project.',
          linkUrl: '/',
          linkText: 'More about builders risk insurance >',
        },
        {
            id: 4,
            title: 'Building insurance',
            description:
              'With our building property coverage policies, you and your business are protected in case your building is damaged and requires repair or rebuilding.',
            linkUrl: '',
            linkText: 'More about building insurance >',
          },
          {
            id: 5,
            title: 'Business auto insurance',
            description:
              'If driving is an important part of your business, we are ready to help you determine the most appropriate commercial auto coverages for your company.',
            linkUrl: '/',
            linkText: 'More about business auto insurance >',
          },
          {
            id: 6,
            title: 'Business income insurance',
            description:
              'Property damage shouldn’t result in lost income. With our business income solutions, we’ll help you get back to business as you recover from property damage.',
            linkUrl: '/',
            linkText: 'More about business income insurance >',
          },
      ];
    return (
        <>
            <div className='insurance_products'>
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />

                    {/* intro section  */}
                    <PageHeaderIntro Data={HeaderData} heading="Our products" />
                    
                    {/* Layout */}
                    <NewsCard Title="All industries:" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS"/>
                </Container>
            </div>
        </>
    )
}

export default InsuranceProduct